module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_vm._l((_vm.centerSpots), function(spot) {
    return _c('g', {
      key: spot.id
    }, [_c('visualization-contour-spot', {
      attrs: {
        "spot": spot,
        "layer-type": 'humidity'
      }
    })], 1)
  }), _vm._v(" "), _c('map-mask-image'), _vm._v(" "), _vm._l((_vm.individualSpots), function(spot) {
    return _c('g', {
      key: spot.id
    }, [_c('visualization-contour-spot', {
      attrs: {
        "spot": spot,
        "layer-type": 'humidity'
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063665cf","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/layer/humidity.vue
// module id = 891
// module chunks = 0